import { isEmpty } from 'lodash'

export const prepareFilters = (
    { report_types, ...filters },
    severityGroup,
    withAssignedToggle
) => {
    // TODO: remove severityGroup usage
    if (!severityGroup) {
        return filters
    }

    let reportTypes
    if (!isEmpty(report_types)) {
        reportTypes = [...report_types]
        if (report_types.includes(1)) {
            reportTypes.push(0, 3, 11)
        }
    }

    /* const filtersData = {
        ...filters,
        report_types: report_types
            ? report_types?.map(i => severityGroup[i]).flat()
            : undefined
    } */
    const filtersData = {
        ...filters,
        report_types: reportTypes
    }
    if (!withAssignedToggle) filtersData.is_assigned = true
    return filtersData
}
